/* eslint-disable no-use-before-define */
export default () => {
  const init = () => {
    const targetNode = document.querySelector(
      '[data-section="product-featured-reviews"]',
    );

    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (
              node.classList &&
              node.classList.contains('yotpo-display-wrapper')
            ) {
              targetNode.classList.remove('hidden');
              observer.disconnect();
            }
          });
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, { childList: true, subtree: true });
  };

  init();
};
